import React from 'react';
import styled from 'styled-components';

import TitleHeader from 'components/presenters/header/TitleHeader';
import AccountDeleteForm from 'components/containers/withdrawal/AccountDeleteForm';

export default function AccountDeleteLayout() {
    return (
        <AccountWithdrawWrapper>
            <HeaderWrapper>
                <TitleHeader title={'회원탈퇴'}/>
            </HeaderWrapper>
            <BodyWrapper>
                <AccountDeleteForm />
            </BodyWrapper>
        </AccountWithdrawWrapper>
    )
}

const AccountWithdrawWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`;

const HeaderWrapper = styled.div`
    flex : 0 1 auto;
    width: 100%;
    height: calc(100vw*(51/375));
    min-height: calc(100vw*(51/375));
    font-size: calc(100vw * (16 / 375));
    font-weight: 500;
`;

const BodyWrapper = styled.div`
    flex: 1 1 auto;
    height: 100%;
`;
